import { Node } from '@tiptap/core';

export const isDivNode = (name: string) => name === 'div' || name === 'textDiv';

export const DivNode = Node.create({
  name: 'div',

  group: 'block',
  content: 'block*',

  parseHTML() {
    return [{ tag: 'div' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', HTMLAttributes, 0];
  }
});

/** Bare div text must inherit the div's typography, without a generated paragraph. */
export const TextDivNode = DivNode.extend({
  name: 'textDiv',
  content: 'inline*',

  parseHTML() {
    return [
      {
        tag: 'div',
        priority: 51,
        getAttrs: (element) =>
          element.querySelector(
            'address,article,aside,blockquote,div,dl,fieldset,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hr,img,main,nav,ol,p,pre,section,table,ul'
          )
            ? false
            : null
      }
    ];
  }
});
